import React from "react";
import { connect } from "react-redux";
import "./_RingSelectModal.scss";
import { Header } from "..";
import { ReactComponent as Cross } from "../../assets/svg/cross.svg";
import {
  toggleRingSelectModal,
  toggleHolderRingCollections,
  toggleMainRingCollections,
  closeRingSelectModals,
} from "../../redux/actions";
import RingSelectList from "../RingSelectlist/RingSelectList";

class RingSelectModal extends React.Component {
  renderCollectionFilters = (collectionsList, mainRing = true) => {
    const {
      selectedMainRingCollections,
      selectedHolderRingCollections,
    } = this.props;
    if (collectionsList && collectionsList.items) {
      return (
        <div className="collection-filters">
          {collectionsList.items.map((item) => {
            if (item.necklace === false) {
              let buttonClass = "collection-button";
              if (mainRing) {
                buttonClass = selectedMainRingCollections.includes(item.id)
                  ? "collection-button active"
                  : "collection-button";
              } else {
                buttonClass = selectedHolderRingCollections.includes(item.id)
                  ? "collection-button active"
                  : "collection-button";
              }
              return (
                <button
                  className={buttonClass}
                  key={item.id}
                  onClick={() => this.onButtonPress(item.id, mainRing)}
                >
                  {item.title}
                </button>
              );
            } else {
              return null;
            }
          })}
        </div>
      );
    }
  };

  onButtonPress = (id, type) => {
    if (type) {
      this.props.toggleMainRingCollections(id);
    } else {
      this.props.toggleHolderRingCollections(id);
    }
  };

  render() {
    const {
      mainRingSelectTitle,
      mainRingSelectSubtitle,
      holderRingSelectTitle,
      holderRingSelectSubtitle,
      modalMainRingOpen,
      modalHolderRingOpen,
      collectionsList,
    } = this.props;
    let modalIsOpen = false;
    if (modalMainRingOpen) {
      modalIsOpen = true;
    }
    if (modalHolderRingOpen) {
      modalIsOpen = true;
    }
    const titleText = modalMainRingOpen
      ? mainRingSelectTitle
      : holderRingSelectTitle;
    const subTitleText = modalMainRingOpen
      ? mainRingSelectSubtitle
      : holderRingSelectSubtitle;
    const modalClass = modalIsOpen
      ? "ring-select-modal open"
      : "ring-select-modal";

    return (
      <div className={modalClass}>
        <Header titleText={titleText} />
        <button
          onClick={() => this.props.closeRingSelectModals()}
          className="close-button"
        >
          <Cross className="close-button-icon" />
        </button>
        <div className="ring-select-modal-container">
          <span className="subtitle">{subTitleText}</span>
          {this.renderCollectionFilters(collectionsList, modalMainRingOpen)}
          <RingSelectList />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ring, configuratorPage, collection }) => {
  const { mainRings, holderRings } = ring;
  const { modalMainRingOpen, modalHolderRingOpen } = configuratorPage;
  const {
    collectionsList,
    selectedMainRingCollections,
    selectedHolderRingCollections,
  } = collection;

  return {
    mainRings,
    holderRings,
    modalMainRingOpen,
    modalHolderRingOpen,
    collectionsList,
    selectedMainRingCollections,
    selectedHolderRingCollections,
  };
};

export default connect(mapStateToProps, {
  toggleRingSelectModal,
  toggleHolderRingCollections,
  toggleMainRingCollections,
  closeRingSelectModals,
})(RingSelectModal);
